import Typography from '@components/Typography';
import palette from '@utils/theme/palette';
import Tooltip from '@components/ui/Tooltip/next';
import { HotelListBoardTypeViewModel } from '@api/v3';

import {
  BoardTypesItem,
  BoardTypesItemsWrapper,
  BoardTypesWrapper,
  DesktopListingItemBoardTypeContainer,
} from './styled';

const BoardType = ({
  boardType,
  boardTypes,
}: {
  boardType?: string;
  boardTypes: Array<HotelListBoardTypeViewModel>;
}) => {
  return (
    <DesktopListingItemBoardTypeContainer>
      <Typography variant='caption2' weight='Light' color='NL800'>
        {boardType}
      </Typography>
      {boardType && boardTypes.length ? (
        <Tooltip
          overlayInnerStyle={{
            textAlign: 'left',
            width: '150px',
            backgroundColor: palette.NL0,
            padding: '8px',
          }}
          arrowColor={palette.NL0}
          overlayStyle={{
            backgroundColor: palette.NL0,
            borderRadius: '8px',
          }}
          placement='bottom'
          title={
            <BoardTypesItemsWrapper>
              {boardTypes?.map((item, index) => (
                <BoardTypesItem key={index}>
                  <Typography color='D400' variant='caption2' weight='Light'>
                    {item.name}
                  </Typography>
                </BoardTypesItem>
              ))}
            </BoardTypesItemsWrapper>
          }
          getPopupContainer={(node) => node}
        >
          <BoardTypesWrapper>
            <Typography color='NL800' variant='caption3' weight='Bold'>
              +{boardTypes.length}
            </Typography>
          </BoardTypesWrapper>
        </Tooltip>
      ) : null}
    </DesktopListingItemBoardTypeContainer>
  );
};

export default BoardType;
